// extracted by mini-css-extract-plugin
export default {"subscribeForm":"lRc_ZS","single":"fQPoak"};